import Login from './pages/Login.vue'
import NotFound from './pages/404.vue'
import Home from './pages/Home.vue'
import Main from './pages/Main.vue'
import NewsList from './pages/news/NewsList.vue'
import UserList from './pages/user/UserList'
import RoleList from './pages/user/RoleList'
import NewsCompile from './pages/news/NewsCompile'
import CarouselFigureList from './pages/carouselFigure/CarouselFigureList'

import ShieldingPage from './pages/shieldding/ShieldingPage'
import CommentPage from './pages/comment/CommentPage'

import QuestionList from './pages/question/questionList'

let routes = [
  {
    path: '/login',
    component: Login,
    name: '',
    hidden: true
  },
  {
    path: '/404',
    component: NotFound,
    name: '',
    hidden: true
  },
  //{ path: '/main', component: Main },
  {
    id: 100,
    path: '/',
    component: Home,
    name: '权限管理',
    iconCls: 'el-icon-menu',//图标样式class
    children: [
      {path: '/main', component: Main, name: '主页', hidden: true},
      {id: 100100, path: '/user', component: UserList, name: '用户管理', meta: {id: 100100}},
      {id: 100102, path: '/role', component: RoleList, name: '角色管理', meta: {id: 100102}}
    ]
  },
  {
    id: 101,
    path: '/',
    component: Home,
    name: '资讯管理',
    iconCls: 'el-icon-message',//图标样式class
    children: [
      {id: 101108, path: '/news/NewsList', component: NewsList, name: '资讯列表'},
      {id: 101109, path: '/news/NewsCompile', component: NewsCompile, name: '编译资讯'}
    ]
  },
  {
    id: 102,
    path: '/',
    component: Home,
    name: '轮播图管理',
    iconCls: 'el-icon-picture',//图标样式class
    children: [
      {id: 102101, path: '/carouselFigure/CarouselFigureList', component: CarouselFigureList, name: '轮播图列表'}
    ]
  },
  {
    id: 110,
    path: '/',
    component: Home,
    name: '问答管理',
    iconCls: 'el-icon-document',//图标样式class
    children: [
      {
        id: 110101,
        path: '/question/questionList',
        component: QuestionList,
        name: '问答列表'
      }
    ]
  },
  {
    id: 111,
    path: '/',
    component: Home,
    name: '评论管理',
    iconCls: 'el-icon-document',//图标样式class
    children: [
      {
        id: 111100,
        path: '/comment/CommentPage',
        meta: {
          id: 111100
        },
        component: CommentPage,
        name: '评论管理'
      }
    ]
  },
  {
    id: 112,
    path: '/',
    component: Home,
    name: '黑词管理',
    iconCls: 'el-icon-document',//图标样式class
    children: [
      {id: 112100, path: '/shieldding/ShieldingPage', component: ShieldingPage, name: '黑词管理'}
    ]
  },
  {
    path: '*',
    hidden: true,
    redirect: {path: '/404'}
  }
]

export default routes
